// Shared helpers for the moderator-approval QR scan flow. Keeps the payload
// prefix in one place so the player (encoder) and the QR scanner (decoder)
// can't drift apart silently.

export enum ModerationType {
  None = 0,
  AppNotification = 1,
  QRCode = 2,
}

/**
 * Prefix used on moderator-approval QR payloads. The general QR scanner
 * detects this prefix and short-circuits the normal challenge-answer flow
 * into the Approve/Reject prompt.
 */
export const APPROVAL_QR_PREFIX = 'hadv:approval:'

export function buildApprovalQrPayload(requestId: string): string {
  return `${APPROVAL_QR_PREFIX}${requestId}`
}

/**
 * Returns the request id when the scanned payload is one of our approval
 * tokens; null otherwise. Accepts either the raw prefix form or a `?` /
 * `#` suffix in case future encodings want to add query parameters.
 */
export function parseApprovalQrPayload(value: string | null | undefined): string | null {
  if (!value) return null
  if (!value.startsWith(APPROVAL_QR_PREFIX)) return null
  const rest = value.slice(APPROVAL_QR_PREFIX.length).split(/[?#]/)[0]?.trim()
  return rest && rest.length > 0 ? rest : null
}
